import React from 'react';

import LoadingSpinner from '@xingternal/malt-loading-spinner';

import style from './Overlay.css';

const Overlay = ({ isVisible }) => {
  if (!isVisible) return null;

  return (
    <div className={style.overlayWrapper}>
      <LoadingSpinner size="60px" />
    </div>
  );
};

export default Overlay;
